module.exports = __webpack_public_path__ + "img/eix.7a92d44e.jpg";